import { render, staticRenderFns } from "./Stepper2.vue?vue&type=template&id=1264dece&scoped=true&"
import script from "./Stepper2.vue?vue&type=script&lang=js&"
export * from "./Stepper2.vue?vue&type=script&lang=js&"
import style0 from "./Stepper2.vue?vue&type=style&index=0&id=1264dece&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1264dece",
  null
  
)

export default component.exports